var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolanaSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none",
    viewBox: "0 0 120 120",
    id: "solana-sol",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_0_285)",
    d: "M37.195 74.2146C37.6108 73.7988 38.1825 73.5563 38.7889 73.5563H93.7764C94.7812 73.5563 95.2836 74.769 94.5733 75.4793L83.7109 86.3417C83.2951 86.7575 82.7234 87 82.1171 87H27.1296C26.1248 87 25.6224 85.7873 26.3327 85.077L37.195 74.2146Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_0_285)",
    d: "M37.195 33.6583C37.6281 33.2425 38.1998 33 38.7889 33H93.7764C94.7812 33 95.2836 34.2127 94.5733 34.923L83.7109 45.7854C83.2951 46.2012 82.7234 46.4437 82.1171 46.4437H27.1296C26.1248 46.4437 25.6224 45.231 26.3327 44.5207L37.195 33.6583Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_0_285)",
    d: "M83.7109 53.8065C83.2951 53.3908 82.7234 53.1482 82.1171 53.1482H27.1296C26.1248 53.1482 25.6224 54.3609 26.3327 55.0712L37.195 65.9336C37.6108 66.3494 38.1825 66.5919 38.7889 66.5919H93.7764C94.7812 66.5919 95.2836 65.3792 94.5733 64.6689L83.7109 53.8065Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_285",
    x1: -98.281,
    x2: -99.744,
    y1: 22.799,
    y2: 96.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_285",
    x1: -114.921,
    x2: -116.384,
    y1: 14.111,
    y2: 87.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_285",
    x1: -106.654,
    x2: -108.117,
    y1: 18.427,
    y2: 92.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaSol);
export default __webpack_public_path__ + "static/media/solana-sol.c4d58b0c297817c3d32234c41bf0f917.svg";
export { ForwardRef as ReactComponent };